import { Hero } from "@/components/minka/Hero";
import { Seo } from "@/components/minka/Seo";import { Marquee } from "@/components/minka/Marquee";
import { Logline, Concept } from "@/components/minka/Concept";
import { Chapter } from "@/components/minka/Chapter";
import { Closing } from "@/components/minka/Closing";
import { CHAPTERS } from "@/data/minka";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="MINKA — Supernatural Horror Screenplay by Nicola Davis"
        description="MINKA is a supernatural thriller-horror feature screenplay by Nicola Davis — a haunted farmhouse in Iwate, a samurai ghost, a portal to Hell. Available for option."
        path="/"
      />
      <Hero />
      <Logline />
      <Marquee />
      <Concept />
      <section id="synopsis" className="bg-[#07080B]/80 backdrop-blur-[2px]" data-testid="synopsis-section">
        {CHAPTERS.map((c) => <Chapter key={c.num} c={c} />)}
      </section>
      <Closing />
    </div>
  );
}
